module.exports = __webpack_public_path__ + "img/天象星盤.cc877e1b.png";